export const consultoriaStatus = {
    AGUARDANDO_ACEITACAO_CREDENCIADA: 0,
    FINALIZADA_SEM_RESPOSTA_CREDENCIADA: 1,
    FINALIZADA_NAO_ACEITA_CREDENCIADA: 2,
    ACEITA_AGUARDANDO_PAGAMENTO_PELO_CLIENTE: 3,
    FINALIZADA_SEM_PAGAMENTO_PELO_CLIENTE: 4,
    AGUARDANDO_ACEITE_CONDICOES_CONTRATUAIS: 5,
    EM_ANDAMENTO: 6,
    CONCLUIDA_PENDENTE_ANALISE: 7,
    CONCLUIDA_EM_ANALISE: 8,
    CONCLUIDA_PENDENTE_CORRECAO: 9,
    CONCLUIDA_SEM_AVALIACAO: 10,
    FINALIZADA_CANCELADA_PELO_CLIENTE: 11,
    AGUARDANDO_COMPROMETIMENTO_RECURSOS: 12,
    CONCLUIDA_COM_AVALIACAO: 13
}
